import { GetInsurancesBlockContent } from './BlockContent';
import { GetInsurancesBlockDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const getInsurancesConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'getInsurances',
  defaultConfig: {},
  configFields: undefined,
  BlockContent: GetInsurancesBlockContent,
  documentationMarkdown: GetInsurancesBlockDocumentationMarkdown,
};
